export class Controller {

    $onChanges() {
        this.tooltipKey = ({
            ADMIN: 'sp-verification-source.admin',
            ADMIN_BY_AD_ACCOUNT: 'sp-verification-source.admin-by-ad-account',
            ADMIN_BY_FACEBOOK_VERIFIED_EMAIL: 'sp-verification-source.admin-by-facebook-verified-email',
            ADMIN_BY_MOBILE_NUMBER: 'sp-verification-source.admin-by-mobile-number',
            ADMIN_BY_SPID: 'sp-verification-source.admin-by-spid',
            ADMIN_BY_USER_VERIFIED_EMAIL: 'sp-verification-source.admin-by-user-verified-email',
            ADMIN_BY_VERIFIED_EMAIL: 'sp-verification-source.admin-by-verified-email',
            ANOTHER_COMPANY: 'sp-verification-source.another-company',
            THIRD_PARTY_FACEBOOK: 'sp-verification-source.third-party-facebook',
            USER: 'sp-verification-source.user',
        })[this.verificationSource];

        this.iconClass = ({
            ADMIN: 'text-primary fa fa-lg fa-user',
            ADMIN_BY_AD_ACCOUNT: 'text-primary fa fa-lg fa-server',
            ADMIN_BY_FACEBOOK_VERIFIED_EMAIL: 'text-primary fa fa-lg fa-facebook',
            ADMIN_BY_MOBILE_NUMBER: 'text-primary fa fa-lg fa-phone',
            ADMIN_BY_SPID: 'text-primary fa fa-lg fa-user',
            ADMIN_BY_USER_VERIFIED_EMAIL: 'text-primary fa fa-lg fa-envelope',
            ADMIN_BY_VERIFIED_EMAIL: 'text-primary fa fa-lg fa-envelope',
            ANOTHER_COMPANY: 'text-primary fa fa-lg fa-building',
            THIRD_PARTY_FACEBOOK: 'text-primary fa fa-lg fa-facebook-official',
            USER: 'text-primary fa fa-lg fa-user-circle',
        })[this.verificationSource];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-verification-source/sp-verification-source.controller.js